/* Vital Years+ — theme runtime */
(function () {
  'use strict';

  /* ---------------------------------------------------------- mobile nav */
  var header = document.querySelector('[data-vy-header]');
  if (header) {
    var toggle = header.querySelector('[data-vy-menu-toggle]');
    var setOpen = function (open) {
      header.setAttribute('data-menu-open', open ? 'true' : 'false');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    if (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(header.getAttribute('data-menu-open') !== 'true');
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.getAttribute('data-menu-open') === 'true') {
        setOpen(false);
        if (toggle) toggle.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 989) setOpen(false);
    });
  }

  /* ------------------------------------------------------- carousel dots */
  document.querySelectorAll('[data-vy-rail]').forEach(function (rail) {
    var dots = document.querySelector('[data-vy-dots="' + rail.dataset.vyRail + '"]');
    if (!dots) return;
    var items = Array.prototype.slice.call(rail.children);
    var sync = function () {
      var mid = rail.scrollLeft + rail.clientWidth / 2;
      var index = 0;
      items.forEach(function (item, i) {
        if (item.offsetLeft <= mid) index = i;
      });
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    };
    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    sync();
  });


  /* ------------------------------------------------------ PDP gallery */
  var gRail = document.querySelector('[data-vy-rail="gallery"]');
  var gThumbs = document.querySelectorAll('.vy-pdp__thumbs span');
  if (gRail && gThumbs.length) {
    var gSlides = Array.prototype.slice.call(gRail.children);
    var pdpThumbsWrap = gThumbs[0].parentNode;
    pdpThumbsWrap.removeAttribute('aria-hidden');
    gThumbs.forEach(function (t, i) {
      t.style.cursor = 'pointer';
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      t.setAttribute('aria-label', 'Photo ' + (i + 1));
      var go = function () { if (gSlides[i]) gRail.scrollTo({ left: gSlides[i].offsetLeft, behavior: 'smooth' }); };
      t.addEventListener('click', go);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
    var syncThumbs = function () {
      var mid = gRail.scrollLeft + gRail.clientWidth / 2, idx = 0;
      gSlides.forEach(function (sl, i) { if (sl.offsetLeft <= mid) idx = i; });
      gThumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      var gTag = document.querySelector('.vy-pdp__tag');
      if (gTag) gTag.style.opacity = idx === 0 ? '' : '0';
    };
    gRail.addEventListener('scroll', function () { window.requestAnimationFrame(syncThumbs); }, { passive: true });
  }

  /* ------------------------------------------------------------ steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vy-step]');
    if (!btn) return;
    var wrap = btn.closest('.vy-qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.vyStep, 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----------------------------------------------------------- accordion */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-vy-accordion-trigger]');
    if (!head) return;
    var group = head.closest('[data-vy-accordion]');
    var row = head.closest('[data-vy-accordion-row]');
    if (!group || !row) return;
    var open = row.getAttribute('data-open') === 'true';
    group.querySelectorAll('[data-vy-accordion-row]').forEach(function (r) {
      r.setAttribute('data-open', 'false');
      var t = r.querySelector('[data-vy-accordion-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!open) {
      row.setAttribute('data-open', 'true');
      head.setAttribute('aria-expanded', 'true');
    }
  });

  /* ---------------------------------------------------- copy-to-clipboard */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vy-copy]');
    if (!btn) return;
    var value = btn.dataset.vyCopy;
    var done = function () {
      var label = btn.textContent;
      btn.textContent = 'Copied';
      setTimeout(function () { btn.textContent = label; }, 1600);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(value).then(done).catch(function () {});
    else done();
  });
})();
